import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line arrow-body-style
export default makeStyles(() => {
  return {
    ScrollableWrapper__horizontal: ({ padding, overflowWidth, isVisible, isScrollable }) => ({
      'overflowX': isScrollable ? 'scroll !important' : 'hidden',
      'overflowY': 'hidden',
      'paddingTop': `${isScrollable && isVisible ? padding : 0}px`,
      'paddingBottom': `${isScrollable && isVisible ? padding - overflowWidth : 0}px`,
      'scrollbarHeight': isVisible && isScrollable ? 'thin' : 'none',
      '&::-webkit-scrollbar': {
        height: `${isVisible ? overflowWidth : 0}px !important`,
      },
    }),
    ScrollableWrapper__vertical: ({ padding, overflowWidth, isVisible, isScrollable }) => ({
      'overflowY': isScrollable ? 'scroll !important' : 'hidden',
      'overflowX': 'hidden',
      'paddingLeft': `${isScrollable && isVisible ? padding : 0}px`,
      'paddingRight': `${isScrollable && isVisible ? padding - overflowWidth : 0}px`,
      'scrollbarWidth': isVisible && isScrollable ? 'thin' : 'none',
      '&::-webkit-scrollbar': {
        width: `${isVisible ? overflowWidth : 0}px !important`,
      },
    }),
  };
});
